export const extractSellingPlanIntervalFromName = (stringValue: string | undefined) =>
  Number(stringValue?.match(/\d+/)?.[0]) || 0
